import { LineItem } from 'shared/types/wishlist/LineItem';
import { callActionMiddleware } from '@/helpers/utils/callActionHelper';
import { sdk } from 'sdk';

const productToWishlistLineItem = (initialColor: any, initialSize: any, qty: number): LineItem => {
  return {
    lineItemId: initialSize?.key ?? '',
    productId: initialSize?.key ?? '',
    name: initialColor?.name,
    count: qty,
    variant: { sku: initialSize?.key },
    addedAt: new Date(),
    _url: '/product/' + initialColor?.slug + '/' + initialColor?.key, // will move this to common util function later
  };
};

const getAttribute = (name: string, initialSize: any) => {
  const filteredArray = initialSize?.attributesRaw?.filter((arr: any) => {
    return arr.name === name;
  });
  return filteredArray?.length ? filteredArray[0].value : null;
};

const getContentByTitle = async (title: string, withSideId = true) => {
  return callActionMiddleware({
    actionName: 'contentstack/getContentByTitleOnly',
    query: { title: encodeURIComponent(title), withSideId: withSideId },
  }).then((response) => {
    return response.isError ? [] : response.data;
  });
};

const getImagesByPath = async (imageURLs: any, siteId: string) => {
  return sdk
    .callAction({
      actionName: 'contentstack/getImagesByPath',
      query: { imageURLs: encodeURIComponent(imageURLs), siteId: siteId },
    })
    .then((response) => {
      return response?.isError ? [] : response.data;
    });
};

const getFilteredAttribute = (attributeName: string, selectedVariant: any, attributeValue?: any) => {
  const filteredArray = selectedVariant?.attributesRaw?.filter((item: any) => item?.name === attributeName);

  if (attributeValue && filteredArray && Array.isArray(filteredArray[0]?.value)) {
    const matchedValue = filteredArray[0]?.value?.find((value: any) => value === attributeValue);
    return matchedValue ?? null;
  }
  return filteredArray && filteredArray.length ? filteredArray[0]?.value : null;
};

// Outside the component, so they aren't recreated on every render
const normalize = (value: string) => value.trim().toLowerCase();

/**
 * Returns the value of the most specific key whose segments all match.
 * Key format: "department###Footwear@@class###Boot@@subclass###Athletics"
 */
const getMostSpecificMatch = (
  map: Record<string, string>,
  department?: string,
  classValue?: string,
  subClassValue?: string,
): string | undefined => {
  const attributes: Record<string, string | undefined> = {
    department,
    class: classValue,
    subclass: subClassValue,
  };

  let bestValue: string | undefined;
  let bestScore = 0;

  for (const [key, value] of Object.entries(map)) {
    const segments = key.split('@@');

    const allMatch = segments.every((segment) => {
      const [name, expected] = segment.split('###');
      const actual = attributes[name];
      return !!actual && !!expected && normalize(actual) === normalize(expected);
    });

    if (allMatch && segments.length > bestScore) {
      bestValue = value;
      bestScore = segments.length;
    }
  }

  return bestValue;
};

export {
  getAttribute,
  productToWishlistLineItem,
  getContentByTitle,
  getFilteredAttribute,
  getImagesByPath,
  getMostSpecificMatch,
};
